import { forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

/**
 * Botão de ação com ícone que exibe um Tooltip no hover.
 * Usage:
 *   <IconAction icon={Pencil} label="Editar" onClick={...} testid="appt-edit" />
 *
 * Props:
 *   icon: componente de ícone (lucide-react)
 *   label: texto do tooltip (e aria-label)
 *   variant/size: passa para Button
 */
const IconAction = forwardRef(
  ({ icon: Icon, label, variant = "ghost", size = "sm", className, testid, children, ...props }, ref) => {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            ref={ref}
            variant={variant}
            size={size}
            aria-label={label}
            data-testid={testid}
            className={cn("inline-flex items-center justify-center", className)}
            {...props}
          >
            {Icon && <Icon className="w-4 h-4" />}
            {children}
          </Button>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    );
  }
);
IconAction.displayName = "IconAction";

export default IconAction;
